import * as Amplitude from "@amplitude/analytics-browser"

/**
 * User clicked create a new post.
 */
export function createNewPostClicked(source: string) {
  return Amplitude.track("create_new_post_clicked", { source })
}

/**
 * User clicked import a post.
 */
export function importPostClicked(url: string, setCanonicalUrl: boolean) {
  return Amplitude.track("import_post_clicked", {
    url_hostname: new URL(url).hostname,
    set_canonical_url: setCanonicalUrl,
  })
}

/**
 * User clicked on row to open post.
 */
function openPostRowClicked(postId: string) {
  return Amplitude.track("edit_post_click", {
    post_id: postId,
    source: "post_row",
  })
}

/**
 * User clicked view metrics.
 */
export function viewMetricsClicked(postId: string) {
  return Amplitude.track("view_metrics_clicked", { post_id: postId })
}

/**
 * User clicked open post.
 */
export function openPostClicked(postId: string) {
  return Amplitude.track("open_post_link_clicked", {
    post_id: postId,
  })
}

/**
 * User clicked open draft.
 */
export function openDraftClicked(postId: string) {
  return Amplitude.track("open_draft_clicked", { post_id: postId })
}

/**
 * User clicked edit post.
 */
export function editPostClicked(postId: string) {
  return Amplitude.track("edit_post_clicked", {
    post_id: postId,
    source: "post_row_menu_button",
  })
}

/**
 * User clicked copy link.
 * @published - Whether the post who's link to copy is published.
 */
export function copyLinkClicked(postId: string, isPublished?: boolean) {
  return Amplitude.track("copy_link_clicked", {
    post_id: postId,
    published: isPublished ? true : false,
  })
}

/**
 * User clicked show post in feed.
 */
export function showPostClicked(postId: string) {
  return Amplitude.track("show_post_clicked", { post_id: postId })
}

/**
 * User clicked hide post from feed.
 */
export function hidePostClicked(postId: string) {
  return Amplitude.track("hide_post_clicked", { post_id: postId })
}

/**
 * User duplicated post.
 * @published - Whether the post to duplicate is published.
 */
export function duplicatePostClicked(postId: string, isPublished?: boolean) {
  return Amplitude.track("duplicate_post_clicked", {
    post_id: postId,
    published: isPublished ? true : false,
  })
}

/**
 * User unscheduled post.
 */
export function unschedulePostClicked(postId: string) {
  return Amplitude.track("unscheduled_post", { post_id: postId })
}

/**
 * User un-published post.
 */
export function unpublishPostClicked(postId: string) {
  return Amplitude.track("unpublish_post_clicked", { post_id: postId })
}

/**
 * User archived post.
 * @published - Whether the post to archive is published.
 */
export function archivePostClicked(postId: string, isPublished?: boolean) {
  return Amplitude.track("archive_post_clicked", {
    post_id: postId,
    published: isPublished ? true : false,
  })
}

/**
 * User unarchived post.
 */
export function unArchivePostClicked(postId: string) {
  return Amplitude.track("unarchive_post_clicked", { post_id: postId })
}

/**
 * User deleted an archived post.
 */
export function deletePostClicked(postId: string) {
  return Amplitude.track("delete_post_clicked", { post_id: postId })
}
